import { BusHour } from "./BusTimes";

export const BUS_TIMES_SUNDAYS: BusHour[] = [
  {
    hour: 0,
    minute: 5,
  },
  {
    hour: 0,
    minute: 20,
  },
  {
    hour: 0,
    minute: 35,
  },
  {
    hour: 5,
    minute: 39,
  },
  {
    hour: 5,
    minute: 54,
  },
  {
    hour: 6,
    minute: 9,
  },
  {
    hour: 6,
    minute: 24,
  },
  {
    hour: 6,
    minute: 39,
  },
  {
    hour: 6,
    minute: 54,
  },
  {
    hour: 7,
    minute: 9,
  },
  {
    hour: 7,
    minute: 24,
  },
  {
    hour: 7,
    minute: 39,
  },
  {
    hour: 7,
    minute: 54,
  },
  {
    hour: 8,
    minute: 9,
  },
  {
    hour: 8,
    minute: 24,
  },
  {
    hour: 8,
    minute: 39,
  },
  {
    hour: 8,
    minute: 54,
  },
  {
    hour: 9,
    minute: 9,
  },
  {
    hour: 9,
    minute: 24,
  },
  {
    hour: 9,
    minute: 39,
  },
  {
    hour: 9,
    minute: 54,
  },
  {
    hour: 10,
    minute: 9,
  },
  {
    hour: 10,
    minute: 24,
  },
  {
    hour: 10,
    minute: 39,
  },
  {
    hour: 10,
    minute: 49,
  },
  {
    hour: 10,
    minute: 59,
  },
  {
    hour: 11,
    minute: 8,
  },
  {
    hour: 11,
    minute: 18,
  },
  {
    hour: 11,
    minute: 28,
  },
  {
    hour: 11,
    minute: 38,
  },
  {
    hour: 11,
    minute: 48,
  },
  {
    hour: 11,
    minute: 58,
  },
  {
    hour: 12,
    minute: 8,
  },
  {
    hour: 12,
    minute: 18,
  },
  {
    hour: 12,
    minute: 28,
  },
  {
    hour: 12,
    minute: 38,
  },
  {
    hour: 12,
    minute: 48,
  },
  {
    hour: 12,
    minute: 58,
  },
  {
    hour: 13,
    minute: 8,
  },
  {
    hour: 13,
    minute: 18,
  },
  {
    hour: 13,
    minute: 28,
  },
  {
    hour: 13,
    minute: 38,
  },
  {
    hour: 13,
    minute: 48,
  },
  {
    hour: 13,
    minute: 58,
  },
  {
    hour: 14,
    minute: 8,
  },
  {
    hour: 14,
    minute: 18,
  },
  {
    hour: 14,
    minute: 28,
  },
  {
    hour: 14,
    minute: 38,
  },
  {
    hour: 14,
    minute: 48,
  },
  {
    hour: 14,
    minute: 58,
  },
  {
    hour: 15,
    minute: 8,
  },
  {
    hour: 15,
    minute: 18,
  },
  {
    hour: 15,
    minute: 28,
  },
  {
    hour: 15,
    minute: 38,
  },
  {
    hour: 15,
    minute: 48,
  },
  {
    hour: 15,
    minute: 58,
  },
  {
    hour: 16,
    minute: 8,
  },
  {
    hour: 16,
    minute: 18,
  },
  {
    hour: 16,
    minute: 28,
  },
  {
    hour: 16,
    minute: 38,
  },
  {
    hour: 16,
    minute: 48,
  },
  {
    hour: 16,
    minute: 58,
  },
  {
    hour: 17,
    minute: 8,
  },
  {
    hour: 17,
    minute: 18,
  },
  {
    hour: 17,
    minute: 28,
  },
  {
    hour: 17,
    minute: 38,
  },
  {
    hour: 17,
    minute: 48,
  },
  {
    hour: 17,
    minute: 58,
  },
  {
    hour: 18,
    minute: 8,
  },
  {
    hour: 18,
    minute: 18,
  },
  {
    hour: 18,
    minute: 28,
  },
  {
    hour: 18,
    minute: 38,
  },
  {
    hour: 18,
    minute: 48,
  },
  {
    hour: 18,
    minute: 58,
  },
  {
    hour: 19,
    minute: 8,
  },
  {
    hour: 19,
    minute: 18,
  },
  {
    hour: 19,
    minute: 28,
  },
  {
    hour: 19,
    minute: 38,
  },
  {
    hour: 19,
    minute: 48,
  },
  {
    hour: 19,
    minute: 58,
  },
  {
    hour: 20,
    minute: 8,
  },
  {
    hour: 20,
    minute: 18,
  },
  {
    hour: 20,
    minute: 28,
  },
  {
    hour: 20,
    minute: 38,
  },
  {
    hour: 20,
    minute: 48,
  },
  {
    hour: 20,
    minute: 56,
  },
  {
    hour: 21,
    minute: 5,
  },
  {
    hour: 21,
    minute: 20,
  },
  {
    hour: 21,
    minute: 27,
  },
  {
    hour: 21,
    minute: 35,
  },
  {
    hour: 21,
    minute: 50,
  },
  {
    hour: 22,
    minute: 5,
  },
  {
    hour: 22,
    minute: 20,
  },
  {
    hour: 22,
    minute: 35,
  },
  {
    hour: 22,
    minute: 50,
  },
  {
    hour: 23,
    minute: 5,
  },
  {
    hour: 23,
    minute: 20,
  },
  {
    hour: 23,
    minute: 35,
  },
  {
    hour: 23,
    minute: 50,
  },
];
